import React, { FunctionComponent } from 'react';
import { Grid, Typography } from '@material-ui/core';
import DotsLoader from '../../../../../../../../gqlCommon/components/dotsLoader/DotsLoader';
import vehicleIdentificationNumberStyles from './vehicleIdentificationNumberStyles';
import useCustomizeCarContext from '../../../../../../../hooks/useCustomizeCarContext';

const VehicleIdentificationNumber: FunctionComponent = () => {
  const styles = vehicleIdentificationNumberStyles();
  const { selectedCar, loading } = useCustomizeCarContext();

  const { vin } = selectedCar?.stockInfo || {};

  if (loading) {
    return <DotsLoader dataTest="vin:loader" />;
  }

  return (
    <Grid container className={styles.container}>
      <Grid item>
        <Typography className={styles.value} data-test="summary-stock:vin">
          {vin}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default VehicleIdentificationNumber;
